// import React, { useState, useEffect, useCallback, forwardRef } from "react";
// import {
//     Button,
//     Card,
//     Divider,
//     Paper,
//     Grid,
//     SwipeableDrawer,
//     Typography,
//     TextField,
//     CircularProgress, // Added for loading state
//     Alert,
//     Collapse,
//     Box,
//     Stack,          // Added for error display
// } from "@mui/material";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell, { tableCellClasses } from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import axios from "axios";
// import HOST_URL from "../../../utils/Url"; // Ensure this path is correct
// import ToastApp from "../../../ToastApp"; // Ensure this path is correct
// import { toast } from "react-toastify";
// import { useFormik } from "formik";
// // import * as Yup from "yup"; // Removed as no validation schema is defined here
// import Autocomplete from "@mui/material/Autocomplete";
// import { useTranslation } from "react-i18next";
// import PrintIcon from "@mui/icons-material/Print";
// // import dayjs from "dayjs"; // Removed if not directly used in this component
// import { styled } from "@mui/material/styles";
// import DocMngSwipeableDrawer from "./DocMngSwipeableDrawer"; // Ensure this path is correct

// // --- Styled Components (No changes needed here) ---
// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//     [`&.${tableCellClasses.head}`]: {
//         // Using CSS variables or fallback
//         backgroundColor: `var(--header-background, #00009C)`,
//         color: `var(--header-color, ${theme.palette.common.white})`,
//         whiteSpace: 'nowrap', // Prevent wrapping in header cells
//     },
//     [`&.${tableCellClasses.body}`]: {
//         fontSize: 14,
//     },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     "&:nth-of-type(odd)": {
//         backgroundColor: theme.palette.action.hover,
//     },
//     // hide last border
//     "&:last-child td, &:last-child th": {
//         border: 0,
//     },
//     // Ensure consistent border for better visual structure
//     "& td, & th": {
//         borderRight: `1px solid ${theme.palette.divider}`, // Add right border to cells
//     },
//     "& td:last-child, & th:last-child": {
//         borderRight: 0, // Remove right border for the last cell
//     }
// }));

// // --- Cleaned up Row Component ---
// function Row({ row, index, onRowClick }: { row: any; index: number, onRowClick: (rowData: any) => void }) {
//     // Removed state and functions related to editing/modal (openModal, tableData, handleSubmit, etc.)
//     // This component should only display data and handle the click to open details.

//     const handleFileNameClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
//         e.preventDefault(); // Prevent default anchor behavior
//         onRowClick(row);    // Pass the selected row data up
//     };

//     return (
//         <StyledTableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
//             <StyledTableCell align="center">{index + 1}</StyledTableCell>
//             <StyledTableCell>
//                 {/* Use a Button or Link styled component for better accessibility/styling if needed */}
//                 <a
//                     href="#"
//                     style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
//                     onClick={handleFileNameClick}
//                 >
//                     {row.synopsis || 'N/A'} {/* Provide fallback */}
//                 </a>
//             </StyledTableCell>
//             <StyledTableCell>{row.sub_Subject_Name || '-'}</StyledTableCell>
//             <StyledTableCell>{row.fileNo || '-'}</StyledTableCell>
//             <StyledTableCell>{row.fileType_Name || '-'}</StyledTableCell>
//             <StyledTableCell>{row.sub_Subject_Name || '-'}</StyledTableCell>
//             <StyledTableCell>{row.department_Name || '-'}</StyledTableCell>
//             <StyledTableCell>
//                 {row.createdate ? require('moment')(row.createdate).format('DD/MM/YYYY') : '-'}
//             </StyledTableCell>

//         </StyledTableRow>
//     );
// }

// // --- Main Enhanced DocManagerReports Component ---
// const API_ENDPOINT = HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`;
// const DEFAULT_FILTER_INT = -1;
// const DEFAULT_FILTER_STRING = "";

// export default function DocManagerReports() {
//     const { t } = useTranslation();
//     const [filterDrawerOpen, setFilterDrawerOpen] = useState(true);
//     const [data, setData] = useState<any[]>([]); // Initialize as empty array
//     const [loading, setLoading] = useState<boolean>(false); // Loading state
//     const [error, setError] = useState<string | null>(null); // Error state
//     const [selectedRow, setSelectedRow] = useState<any>(null);
//     const [detailsDrawerOpen, setDetailsDrawerOpen] = useState(false);

//     // --- State for Filter Dropdowns ---
//     const [optionSubSubject, setOptionSubSubject] = useState<any[]>([]);
//     const [optionDivision, setOptionDivision] = useState<any[]>([]);
//     const [optionFileType, setOptionFileType] = useState<any[]>([]);
//     const [optionFileNo, setOptionFileNo] = useState<any[]>([]);

//     // --- Static Options ---
//     const statusOption = [
//         { value: "1", label: t("text.Process") }, // Use translation
//         { value: "2", label: t("text.Pending") },
//         { value: "3", label: t("text.Complete") },
//     ];

//     // --- Fetch Data Function ---

//     const devId = localStorage.getItem("devID")

//     const fetchData = useCallback(async (filterParams: FormValues) => {
//         setLoading(true);
//         setError(null);
//         setData([]); // Clear previous data
//         console.log("Fetching data with params:", filterParams);

//         // Ensure default values are used if form values are empty/null
//         const payload = {
//             docMid: filterParams.docMid || DEFAULT_FILTER_INT,
//             fileTypId: filterParams.fileTypId || DEFAULT_FILTER_INT,
//             // divisionid: devId === "null" ? -1 : devId,
//                divisionid: filterParams.divisionid || DEFAULT_FILTER_INT,
//             subsubjId: filterParams.subsubjId || DEFAULT_FILTER_INT,
//             user_Id: filterParams.user_Id || DEFAULT_FILTER_INT, // Assuming -1 is default for user_Id
//             fileNo: filterParams.fileNo || DEFAULT_FILTER_STRING,
//             perFr: filterParams.perFr || DEFAULT_FILTER_STRING,
//             perUt: filterParams.perUt || DEFAULT_FILTER_STRING,
//             complt: filterParams.complt || DEFAULT_FILTER_STRING,
//         };

//         try {
//             const response = await axios.post(API_ENDPOINT, payload);
//             if (response.data.isSuccess) {
//                 setData(response.data.data || []); // Ensure data is an array
//                 if (!response.data.data || response.data.data.length === 0) {
//                     toast.info(t("text.NoDataFound")); // Inform user if no data
//                 }
//             } else {
//                 setError(response.data.mesg || t("text.ErrorFetchingData"));
//                 toast.error(response.data.mesg || t("text.ErrorFetchingData"));
//             }
//         } catch (err: any) {
//             console.error("API Error:", err);
//             const errorMsg = err.response?.data?.mesg || err.message || t("text.NetworkError");
//             setError(errorMsg);
//             toast.error(errorMsg);
//         } finally {
//             setLoading(false);
//         }
//     }, [t]); // Add t to dependency array if translations change

//     // --- Fetch Initial Data and Dropdown Data ---
//     useEffect(() => {
//         // Fetch initial report data with default filters
//         fetchData({
//             docMid: DEFAULT_FILTER_INT,
//             fileTypId: DEFAULT_FILTER_INT,
//             divisionid: DEFAULT_FILTER_INT,
//             subsubjId: DEFAULT_FILTER_INT,
//             user_Id: DEFAULT_FILTER_INT,
//             fileNo: DEFAULT_FILTER_STRING,
//             perFr: DEFAULT_FILTER_STRING,
//             perUt: DEFAULT_FILTER_STRING,
//             complt: DEFAULT_FILTER_STRING,
//         });

//         // Fetch dropdown options
//         const fetchDropdownData = async () => {
//             try {
//                 // SubSubject
//                 const subSubjRes = await axios.post(HOST_URL.HOST_URL2 + "SubSubjForPdf/GetSubSubjForPdf", { sSubId: -1 });
//                 setOptionSubSubject(subSubjRes.data.data.map((item: any) => ({ label: item.subSubj, value: item.sSubId })) || []);

//                 // Division (Document)
//                 const divisionRes = await axios.post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, { id: -1, nodeID: -1, titleID: -1 });
//                 setOptionDivision(divisionRes.data.data.map((item: any) => ({ label: item.name, value: item.id })) || []);

//                 // File Type (File Class)
//                 const fileTypeRes = await axios.post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, { docID: -1, parentDocId: -1, userId: "" });
//                 setOptionFileType(fileTypeRes.data.data.map((item: any) => ({ label: item.doc_Name, value: item.docID })) || []);

//                 // File Number (Optional: Fetch all distinct file numbers initially, or rely on user typing)
//                 // Note: Fetching ALL file numbers might be inefficient if there are many.
//                 // Consider making FileNo a TextField initially or fetching based on other filters.
//                 const fileNoRes: any = await axios.post(API_ENDPOINT, { docMid: -1, fileTypId: -1, divisionid: -1, subsubjId: -1, user_Id: -1, fileNo: "" });
//                 // Get distinct file numbers
//                 const distinctFileNos: any = Array.from(new Set(fileNoRes.data.data.map((item: any) => item.fileNo).filter(Boolean))); // Use Array.from() directly
//                 setOptionFileNo(distinctFileNos.map((fileNo: string) => ({ label: fileNo, value: fileNo })) || []);
//                 setOptionFileNo(distinctFileNos.map((fileNo: string) => ({ label: fileNo, value: fileNo })) || []);

//             } catch (error) {
//                 console.error("Error fetching dropdown data:", error);
//                 toast.error(t("text.ErrorFetchingFilters"));
//             }
//         };

//         fetchDropdownData();
//     }, [fetchData, t]); // Include fetchData and t in dependencies

//     // --- Filter Form Logic ---
//     interface FormValues {
//         docMid: number | null | string; // Allow null for Autocomplete reset
//         fileTypId: number | null | string;
//         divisionid: number | null | string;
//         subsubjId: number | null | string;
//         user_Id: number | null | string; // Consider if user_Id filter is needed
//         fileNo: string | null;
//         perFr: string;
//         perUt: string;
//         complt: string | null;
//     }

//     const initialValues: FormValues = {
//         docMid: null, // Use null for Autocomplete initial/reset state
//         fileTypId: null,
//         divisionid: null,
//         subsubjId: null,
//         user_Id: null, // Or keep as needed
//         fileNo: null,
//         perFr: "",
//         perUt: "",
//         complt: null,
//     };

//     const formik = useFormik({
//         initialValues: initialValues,
//         onSubmit: async (values) => {
//             console.log("Submitting filters:", values);
//             await fetchData(values); // Call the main fetch function
//             // handleCloseDrawer(); // Close drawer after submission
//         },
//     });

//     // --- Event Handlers ---
//     const handleFilterButtonClick = () => {
//         // setFilterDrawerOpen(true);
//         setFilterDrawerOpen((prev) => !prev); // Toggle filter drawer open/close
//     };

//     const handleCloseDrawer = () => {
//         setFilterDrawerOpen(false);
//     };

//     const handleRowClick = (rowData: any) => {
//         setSelectedRow(rowData);
//         setDetailsDrawerOpen(true);
//     };

//     const handleDetailsDrawerClose = () => {
//         setDetailsDrawerOpen(false);
//         setSelectedRow(null); // Clear selected row when closing details
//     };

//     const handlePrint = () => {
//         const contentElement = document.getElementById("report-table-container"); // Target the specific container
//         if (!contentElement) {
//             console.error("Print container not found.");
//             toast.error("Could not find table content to print.");
//             return;
//         }

//         const printWindow = window.open("", "_blank");
//         if (!printWindow) {
//             toast.error("Could not open print window. Check browser pop-up blocker.");
//             return;
//         }

//         // Clone the table content for printing
//         const clonedContent = contentElement.cloneNode(true) as HTMLElement;

//         // Optional: Add specific print styles if needed
//         const styles = `
//             <style>
//                 body { font-family: sans-serif; margin: 20px; }
//                 table { width: 100%; border-collapse: collapse; }
//                 th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
//                 th { background-color: #f2f2f2; }
//                 /* Add any other print-specific styles here */
//             </style>
//         `;

//         printWindow.document.write(`
//             <html>
//                 <head>
//                     <title>${t("text.DocManagerReport")} - ${new Date().toLocaleDateString()}</title>
//                     ${styles}
//                 </head>
//                 <body>
//                     <h2>${t("text.DocManagerReport")}</h2>
//                     ${clonedContent.outerHTML}
//                 </body>
//             </html>
//         `);

//         printWindow.document.close(); // Necessary for some browsers
//         printWindow.focus(); // Necessary for some browsers
//         // Use timeout to ensure content is loaded before printing
//         setTimeout(() => {
//             printWindow.print();
//             printWindow.close();
//         }, 500); // Adjust timeout if needed
//     };

//     const handleClear = () => {
//         formik.resetForm();
//         // Explicitly set Autocomplete values back to null in formik state
//         formik.setFieldValue("divisionid", null);
//         formik.setFieldValue("subsubjId", null);
//         formik.setFieldValue("fileTypId", null);
//         formik.setFieldValue("fileNo", null);
//         formik.setFieldValue("complt", null);
//         // Optionally, refetch all data after clearing filters
//         fetchData(initialValues);
//         toast.info(t("text.FiltersCleared"));
//     };


//     return (
//         <>
//             <ToastApp /> {/* Ensure ToastApp is rendered */}
//             <Card
//                 style={{
//                     width: "100%",
//                     backgroundColor: "var(--page-background-color, #E9FDEE)", // Use CSS variable or fallback
//                     border: ".5px solid #ccc",
//                     marginTop: "2vh", // Use vh for responsive margin
//                 }}
//             >
//                 <Paper
//                     sx={{
//                         width: "100%",
//                         overflow: "hidden",
//                     }}
//                     style={{ padding: "15px" }} // Consistent padding
//                 >
//                     {/* Header Section */}
//                     <Grid container justifyContent="space-between" alignItems="center" sx={{ padding: "10px 20px" }}>
//                         <Grid item>
//                             <Typography variant="h5" component="div">
//                                 {t("text.DocManagerReport")}
//                             </Typography>
//                         </Grid>
//                         <Grid item sx={{ display: 'flex', gap: 2 }}>
//                             <Button
//                                 variant="contained" // More prominent style
//                                 startIcon={<FilterAltIcon />}
//                                 onClick={handleFilterButtonClick}
//                                 className="filter-button" // Add class for potential exclusion during print
//                                 sx={{ textTransform: 'none' }}
//                             >
//                                 {t("text.Filter")}
//                             </Button>
//                             <Button
//                                 variant="contained" // More prominent style
//                                 color="secondary"
//                                 startIcon={<PrintIcon />}
//                                 onClick={handlePrint}
//                                 className="print-button" // Add class for potential exclusion during print
//                                 sx={{ textTransform: 'none' }}
//                                 disabled={loading || data.length === 0} // Disable if loading or no data
//                             >
//                                 {t("text.Print")}
//                             </Button>
//                         </Grid>
//                     </Grid>

//                     <Divider sx={{ marginY: 2 }} />

//                     {/* Filter Drawer */}
//                     <Collapse in={filterDrawerOpen} timeout="auto" unmountOnExit>
//                         {/* Added Card for better visual grouping of filters */}
//                         <Card variant="outlined" sx={{ p: 2, mb: 2, backgroundColor: 'background.paper' }}>
//                             <Typography variant="subtitle1" gutterBottom sx={{ mb: 2, fontWeight: 'medium' }}>
//                                 {t("text.FilterOptions")}
//                             </Typography>
//                             <Box component="form" onSubmit={formik.handleSubmit} id="filter-collapse-content">
//                                 <Grid container spacing={2.5}>
//                                     {/* Filter Inputs */}
//                                     <Grid item xs={12} sm={6} md={4}>
//                                         <Autocomplete
//                                             disablePortal
//                                             options={optionDivision}
//                                             getOptionLabel={(option) => option.label || ""}
//                                             fullWidth
//                                             size="small"
//                                             value={optionDivision.find(opt => opt.value === formik.values.divisionid) || null}
//                                             onChange={(event, newValue) => {
//                                                 formik.setFieldValue("divisionid", newValue?.value ?? null);
//                                             }}
//                                             renderInput={(params) => (
//                                                 <TextField {...params} label={t("text.SelectDivision")} />
//                                             )}
//                                             isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={12} sm={6} md={4}>
//                                         <Autocomplete
//                                             disablePortal
//                                             options={optionSubSubject}
//                                             getOptionLabel={(option) => option.label || ""}
//                                             fullWidth
//                                             size="small"
//                                             value={optionSubSubject.find(opt => opt.value === formik.values.subsubjId) || null}
//                                             onChange={(event, newValue) => {
//                                                 formik.setFieldValue("subsubjId", newValue?.value ?? null);
//                                             }}
//                                             renderInput={(params) => (
//                                                 <TextField {...params} label={t("text.SelectSubSubject")} />
//                                             )}
//                                             isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={12} sm={6} md={4}>
//                                         <Autocomplete
//                                             disablePortal
//                                             options={optionFileType}
//                                             getOptionLabel={(option) => option.label || ""}
//                                             fullWidth
//                                             size="small"
//                                             value={optionFileType.find(opt => opt.value === formik.values.fileTypId) || null}
//                                             onChange={(event, newValue) => {
//                                                 formik.setFieldValue("fileTypId", newValue?.value ?? null);
//                                             }}
//                                             renderInput={(params) => (
//                                                 <TextField {...params} label={t("text.SelectFileType")} />
//                                             )}
//                                             isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={12} sm={6} md={4}>
//                                         <Autocomplete
//                                             freeSolo
//                                             disablePortal
//                                             options={optionFileNo}
//                                             getOptionLabel={(option) => typeof option === 'string' ? option : option.label || ""}
//                                             fullWidth
//                                             size="small"
//                                             value={optionFileNo.find(opt => opt.value === formik.values.fileNo) || formik.values.fileNo || null}
//                                             onChange={(event, newValue) => {
//                                                 formik.setFieldValue("fileNo", typeof newValue === 'string' ? newValue : newValue?.value ?? null);
//                                             }}
//                                             renderInput={(params) => (
//                                                 <TextField {...params} label={t("text.SelectOrEnterFileNo")} />
//                                             )}
//                                             isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                         />
//                                     </Grid>

//                                     {/* <Grid item xs={12} sm={6} md={4}>
//                                         <Autocomplete
//                                             disablePortal
//                                             options={statusOption}
//                                             getOptionLabel={(option) => option.label || ""}
//                                             fullWidth
//                                             size="small"
//                                             value={statusOption.find(opt => opt.value === formik.values.complt) || null}
//                                             onChange={(event, newValue) => {
//                                                 formik.setFieldValue("complt", newValue?.value ?? null);
//                                             }}
//                                             renderInput={(params) => (
//                                                 <TextField {...params} label={t("text.SelectStatus")} />
//                                             )}
//                                             isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                         />
//                                     </Grid> */}

//                                     {/* <Grid item xs={12} sm={6} md={4}>
//                                         <TextField
//                                             name="perFr"
//                                             label={t("text.FromDate")}
//                                             size="small"
//                                             type="date"
//                                             fullWidth
//                                             value={formik.values.perFr}
//                                             onChange={formik.handleChange}
//                                             InputLabelProps={{ shrink: true }}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={12} sm={6} md={4}>
//                                         <TextField
//                                             name="perUt"
//                                             label={t("text.ToDate")}
//                                             size="small"
//                                             type="date"
//                                             fullWidth
//                                             value={formik.values.perUt}
//                                             onChange={formik.handleChange}
//                                             InputLabelProps={{ shrink: true }}
//                                             inputProps={{ min: formik.values.perFr || undefined }}
//                                         />
//                                     </Grid> */}

//                                     {/* Filter Actions */}
//                                     <Grid item xs={12}>
//                                         <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ mt: 1 }}>
//                                             <Button
//                                                 type="button"
//                                                 variant="outlined"
//                                                 color="secondary"
//                                                 onClick={handleClear}
//                                                 disabled={loading}
//                                                 sx={{ textTransform: 'none' }}
//                                             >
//                                                 {t("text.Clear")}
//                                             </Button>
//                                             <Button
//                                                 type="submit"
//                                                 variant="contained"
//                                                 color="primary"
//                                                 disabled={loading}
//                                                 sx={{ textTransform: 'none' }}
//                                                 startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
//                                             >
//                                                 {loading ? t("text.Searching") + "..." : t("text.Search")}
//                                             </Button>
//                                         </Stack>
//                                     </Grid>
//                                 </Grid>
//                             </Box>
//                         </Card>
//                     </Collapse>
//                     {/* <SwipeableDrawer
//                         anchor="right"
//                         open={filterDrawerOpen}
//                         onClose={handleCloseDrawer}
//                         onOpen={handleFilterButtonClick} // Can keep this or remove if not needed
//                         PaperProps={{
//                             style: {
//                                 width: 320, // Slightly wider for better spacing
//                                 padding: '20px 15px', // Add padding inside drawer
//                                 // boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.15)",
//                             },
//                         }}
//                         style={{ zIndex: 1300 }} // Ensure drawer is on top
//                     >
//                         <Typography variant="h6" align="center" sx={{ marginBottom: 2 }}>
//                             {t("text.FilterOptions")}
//                         </Typography>
//                         <Divider sx={{ marginBottom: 3 }} />

//                         <form onSubmit={formik.handleSubmit}>
//                             <Grid container spacing={2.5}> 
//                                 <Grid item xs={12}>
//                                     <Autocomplete
//                                         options={optionDivision}
//                                         getOptionLabel={(option) => option.label || ""}
//                                         value={optionDivision.find(opt => opt.value === formik.values.divisionid) || null}
//                                         onChange={(event, newValue) => {
//                                             formik.setFieldValue("divisionid", newValue?.value ?? null);
//                                         }}
//                                         renderInput={(params) => (
//                                             <TextField {...params} label={t("text.SelectDivision")} size="small" />
//                                         )}
//                                         isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <Autocomplete
//                                         options={optionSubSubject}
//                                         getOptionLabel={(option) => option.label || ""}
//                                         value={optionSubSubject.find(opt => opt.value === formik.values.subsubjId) || null}
//                                         onChange={(event, newValue) => {
//                                             formik.setFieldValue("subsubjId", newValue?.value ?? null);
//                                         }}
//                                         renderInput={(params) => (
//                                             <TextField {...params} label={t("text.SelectSubSubject")} size="small" />
//                                         )}
//                                         isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <Autocomplete
//                                         options={optionFileType}
//                                         getOptionLabel={(option) => option.label || ""}
//                                         value={optionFileType.find(opt => opt.value === formik.values.fileTypId) || null}
//                                         onChange={(event, newValue) => {
//                                             formik.setFieldValue("fileTypId", newValue?.value ?? null);
//                                         }}
//                                         renderInput={(params) => (
//                                             <TextField {...params} label={t("text.SelectFileType")} size="small" />
//                                         )}
//                                         isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <Autocomplete
//                                         freeSolo // Allow typing custom values if needed, or remove if strictly dropdown
//                                         options={optionFileNo}
//                                         getOptionLabel={(option) => typeof option === 'string' ? option : option.label || ""}
//                                         value={optionFileNo.find(opt => opt.value === formik.values.fileNo) || formik.values.fileNo || null} // Handle string or object value
//                                         onChange={(event, newValue) => {
//                                             formik.setFieldValue("fileNo", typeof newValue === 'string' ? newValue : newValue?.value ?? null);
//                                         }}
//                                         renderInput={(params) => (
//                                             <TextField {...params} label={t("text.SelectOrEnterFileNo")} size="small" />
//                                         )}
//                                         isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <Autocomplete
//                                         options={statusOption}
//                                         getOptionLabel={(option) => option.label || ""}
//                                         value={statusOption.find(opt => opt.value === formik.values.complt) || null}
//                                         onChange={(event, newValue) => {
//                                             formik.setFieldValue("complt", newValue?.value ?? null);
//                                         }}
//                                         renderInput={(params) => (
//                                             <TextField {...params} label={t("text.SelectStatus")} size="small" />
//                                         )}
//                                         isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <TextField
//                                         name="perFr"
//                                         label={t("text.FromDate")}
//                                         value={formik.values.perFr}
//                                         onChange={formik.handleChange}
//                                         onBlur={formik.handleBlur}
//                                         InputLabelProps={{ shrink: true }}
//                                         size="small"
//                                         type="date"
//                                         fullWidth
//                                         sx={{ backgroundColor: "white" }} // Consider removing if theme handles it
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <TextField
//                                         name="perUt"
//                                         label={t("text.ToDate")}
//                                         value={formik.values.perUt}
//                                         onChange={formik.handleChange}
//                                         onBlur={formik.handleBlur}
//                                         InputLabelProps={{ shrink: true }}
//                                         size="small"
//                                         type="date"
//                                         fullWidth
//                                         sx={{ backgroundColor: "white" }}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12} sx={{ textAlign: 'center', marginTop: 2 }}> 
//                                     <Button
//                                         type="submit"
//                                         variant="contained"
//                                         sx={{ marginRight: 1 }}
//                                         disabled={loading}
//                                     >
//                                         {loading ? t("text.Searching") + "..." : t("text.Search")}
//                                     </Button>
//                                     <Button
//                                         type="button" // Important: type="button" to prevent form submission
//                                         variant="outlined" // Different style for clear
//                                         onClick={handleClear}
//                                         disabled={loading}
//                                     >
//                                         {t("text.Clear")}
//                                     </Button>
//                                 </Grid>
//                             </Grid>
//                         </form>
//                     </SwipeableDrawer> */}

//                     {/* Table Area */}
//                     <TableContainer
//                         component={Paper}
//                         id="report-table-container" // Added ID for printing
//                         sx={{
//                             maxHeight: "65vh", // Responsive height
//                             marginTop: 2,
//                             border: "1px solid #ddd", // Subtle border
//                         }}
//                     >
//                         <Table stickyHeader aria-label="document manager reports table">
//                             <TableHead>
//                                 <TableRow>
//                                     {/* Removed the extra header row spanning columns */}
//                                     <StyledTableCell align="center">{t("text.SrNo")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.FileName")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.Subject")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.FileNo")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.FileType")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.SubSubjectName")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.DivisionName")}</StyledTableCell>
//                                       <StyledTableCell align="left">{t("text.Date")}</StyledTableCell>

//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {loading ? (
//                                     <TableRow>
//                                         <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
//                                             <CircularProgress />
//                                             <Typography sx={{ marginTop: 1 }}>{t("text.LoadingData")}...</Typography>
//                                         </TableCell>
//                                     </TableRow>
//                                 ) : error ? (
//                                     <TableRow>
//                                         <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
//                                             <Alert severity="error" sx={{ justifyContent: 'center' }}>{error}</Alert>
//                                         </TableCell>
//                                     </TableRow>
//                                 ) : data.length === 0 ? (
//                                     <TableRow>
//                                         <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
//                                             <Typography>{t("text.NoReportsFound")}</Typography>
//                                         </TableCell>
//                                     </TableRow>
//                                 ) : (
//                                     data.map((row: any, index: number) => (
//                                         <Row
//                                             key={row.docMid || index} // Use docMid or fallback to index as key
//                                             row={row}
//                                             index={index}
//                                             onRowClick={handleRowClick} // Pass handler down
//                                         />
//                                     ))
//                                 )}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Paper>
//             </Card>

//             {/* Details Drawer */}
//             <DocMngSwipeableDrawer
//                 open={detailsDrawerOpen}
//                 onClose={handleDetailsDrawerClose}
//                 title={selectedRow ? `# ${selectedRow?.synopsis || 'N/A'} ${t('text.Details')}` : t('text.DocumentManager')}
//                 userData={selectedRow}
//             // Pass any necessary functions for editing/actions inside the drawer
//             />
//         </>
//     );
// }



















// import React, { useState, useEffect, useCallback } from "react";
// import {
//     Button,
//     Card,
//     Divider,
//     Paper,
//     Grid,
//     Typography,
//     TextField,
//     CircularProgress,
//     Alert,
//     Collapse,
//     Box,
//     Stack,
//     TablePagination,
//     InputAdornment,
//     IconButton,
// } from "@mui/material";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell, { tableCellClasses } from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import axios from "axios";
// import HOST_URL from "../../../utils/Url";
// import ToastApp from "../../../ToastApp";
// import { toast } from "react-toastify";
// import { useFormik } from "formik";
// import Autocomplete from "@mui/material/Autocomplete";
// import { useTranslation } from "react-i18next";
// import PrintIcon from "@mui/icons-material/Print";
// import SearchIcon from "@mui/icons-material/Search";
// import { styled } from "@mui/material/styles";
// import DocMngSwipeableDrawer from "./DocMngSwipeableDrawer";
// import loged from "../../../assets/images/DrawerLogo.png";

// // --- Styled Components ---
// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//     [`&.${tableCellClasses.head}`]: {
//         backgroundColor: `var(--header-background, #00009C)`,
//         color: `var(--header-color, ${theme.palette.common.white})`,
//         whiteSpace: 'nowrap',
//         padding: '8px 12px',
//         fontSize: '0.875rem',
//     },
//     [`&.${tableCellClasses.body}`]: {
//         fontSize: '0.8125rem',
//         padding: '8px 12px',
//         maxWidth: '200px',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         whiteSpace: 'nowrap',
//     },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     "&:nth-of-type(odd)": {
//         backgroundColor: theme.palette.action.hover,
//     },
//     "&:last-child td, &:last-child th": {
//         border: 0,
//     },
//     "& td, & th": {
//         borderRight: `1px solid ${theme.palette.divider}`,
//     },
//     "& td:last-child, & th:last-child": {
//         borderRight: 0,
//     }
// }));

// // --- Row Component ---
// function Row({ row, index, onRowClick }: { row: any; index: number, onRowClick: (rowData: any) => void }) {
//     const handleFileNameClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
//         e.preventDefault();
//         onRowClick(row);
//     };

//     return (
//         <StyledTableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
//             <StyledTableCell align="center">{index + 1}</StyledTableCell>
//             <StyledTableCell>
//                 <a
//                     href="#"
//                     style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
//                     onClick={handleFileNameClick}
//                 >
//                     {row.synopsis || 'N/A'}
//                 </a>
//             </StyledTableCell>
//             <StyledTableCell title={row.sub_Subject_Name}>{row.sub_Subject_Name || '-'}</StyledTableCell>
//             <StyledTableCell>{row.fileNo || '-'}</StyledTableCell>
//             <StyledTableCell>{row.fileType_Name || '-'}</StyledTableCell>
//             <StyledTableCell title={row.sub_Subject_Name}>{row.sub_Subject_Name || '-'}</StyledTableCell>
//             <StyledTableCell title={row.department_Name}>{row.department_Name || '-'}</StyledTableCell>
//             <StyledTableCell>
//                 {row.createdate ? new Date(row.createdate).toLocaleDateString() : '-'}
//             </StyledTableCell>
//         </StyledTableRow>
//     );
// }

// // --- Main Component ---
// const API_ENDPOINT = HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`;
// const DEFAULT_FILTER_INT = -1;
// const DEFAULT_FILTER_STRING = "";

// export default function DocManagerReports() {
//     const { t } = useTranslation();
//     const [filterDrawerOpen, setFilterDrawerOpen] = useState(true);
//     const [data, setData] = useState<any[]>([]);
//     const [filteredData, setFilteredData] = useState<any[]>([]);
//     const [loading, setLoading] = useState<boolean>(false);
//     const [error, setError] = useState<string | null>(null);
//     const [selectedRow, setSelectedRow] = useState<any>(null);
//     const [detailsDrawerOpen, setDetailsDrawerOpen] = useState(false);

//     // Pagination state
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(10);

//     // Search state
//     const [searchTerm, setSearchTerm] = useState("");

//     // Filter dropdowns state
//     const [optionSubSubject, setOptionSubSubject] = useState<any[]>([]);
//     const [optionDivision, setOptionDivision] = useState<any[]>([]);
//     const [optionFileType, setOptionFileType] = useState<any[]>([]);
//     const [optionFileNo, setOptionFileNo] = useState<any[]>([]);

//     // Static Options
//     const statusOption = [
//         { value: "1", label: t("text.Process") },
//         { value: "2", label: t("text.Pending") },
//         { value: "3", label: t("text.Complete") },
//     ];

//     // Handle pagination
//     const handleChangePage = (event: unknown, newPage: number) => {
//         setPage(newPage);
//     };

//     const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     };

//     // Handle search
//     const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
//         const term = event.target.value.toLowerCase();
//         setSearchTerm(term);

//         if (term === "") {
//             setFilteredData(data);
//         } else {
//             const filtered = data.filter(item =>
//                 Object.values(item).some(val =>
//                     val && val.toString().toLowerCase().includes(term)
//                 )
//             );
//             setFilteredData(filtered);
//         }
//         setPage(0); // Reset to first page when searching
//     };

//     // Apply search when data changes
//     useEffect(() => {
//         if (searchTerm) {
//             const filtered = data.filter(item =>
//                 Object.values(item).some(val =>
//                     val && val.toString().toLowerCase().includes(searchTerm)
//                 )
//             );
//             setFilteredData(filtered);
//         } else {
//             setFilteredData(data);
//         }
//     }, [data, searchTerm]);

//     // Fetch Data Function
//     const fetchData = useCallback(async (filterParams: FormValues) => {
//         setLoading(true);
//         setError(null);
//         setData([]);
//         console.log("Fetching data with params:", filterParams);

//         const payload = {
//             docMid: filterParams.docMid || DEFAULT_FILTER_INT,
//             fileTypId: filterParams.fileTypId || DEFAULT_FILTER_INT,
//             divisionid: filterParams.divisionid || DEFAULT_FILTER_INT,
//             subsubjId: filterParams.subsubjId || DEFAULT_FILTER_INT,
//             user_Id: filterParams.user_Id || DEFAULT_FILTER_INT,
//             fileNo: filterParams.fileNo || DEFAULT_FILTER_STRING,
//             perFr: filterParams.perFr || DEFAULT_FILTER_STRING,
//             perUt: filterParams.perUt || DEFAULT_FILTER_STRING,
//             complt: filterParams.complt || DEFAULT_FILTER_STRING,
//         };

//         try {
//             const response = await axios.post(API_ENDPOINT, payload);
//             if (response.data.isSuccess) {
//                 setData(response.data.data || []);
//                 if (!response.data.data || response.data.data.length === 0) {
//                     toast.info(t("text.NoDataFound"));
//                 }
//             } else {
//                 setError(response.data.mesg || t("text.ErrorFetchingData"));
//                 toast.error(response.data.mesg || t("text.ErrorFetchingData"));
//             }
//         } catch (err: any) {
//             console.error("API Error:", err);
//             const errorMsg = err.response?.data?.mesg || err.message || t("text.NetworkError");
//             setError(errorMsg);
//             toast.error(errorMsg);
//         } finally {
//             setLoading(false);
//         }
//     }, [t]);

//     // Fetch Initial Data and Dropdown Data
//     useEffect(() => {
//         fetchData({
//             docMid: DEFAULT_FILTER_INT,
//             fileTypId: DEFAULT_FILTER_INT,
//             divisionid: DEFAULT_FILTER_INT,
//             subsubjId: DEFAULT_FILTER_INT,
//             user_Id: DEFAULT_FILTER_INT,
//             fileNo: DEFAULT_FILTER_STRING,
//             perFr: DEFAULT_FILTER_STRING,
//             perUt: DEFAULT_FILTER_STRING,
//             complt: DEFAULT_FILTER_STRING,
//         });

//         const fetchDropdownData = async () => {
//             try {
//                 // SubSubject
//                 const subSubjRes = await axios.post(HOST_URL.HOST_URL2 + "SubSubjForPdf/GetSubSubjForPdf", { sSubId: -1 });
//                 setOptionSubSubject(subSubjRes.data.data.map((item: any) => ({ label: item.subSubj, value: item.sSubId })) || []);

//                 // Division
//                 const divisionRes = await axios.post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, { id: -1, nodeID: -1, titleID: -1 });
//                 setOptionDivision(divisionRes.data.data.map((item: any) => ({ label: item.name, value: item.id })) || []);

//                 // File Type
//                 const fileTypeRes = await axios.post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, { docID: -1, parentDocId: -1, userId: "" });
//                 setOptionFileType(fileTypeRes.data.data.map((item: any) => ({ label: item.doc_Name, value: item.docID })) || []);

//                 // File Number
//                 const fileNoRes: any = await axios.post(API_ENDPOINT, { docMid: -1, fileTypId: -1, divisionid: -1, subsubjId: -1, user_Id: -1, fileNo: "" });
//                 const distinctFileNos: any = Array.from(new Set(fileNoRes.data.data.map((item: any) => item.fileNo).filter(Boolean)));
//                 setOptionFileNo(distinctFileNos.map((fileNo: string) => ({ label: fileNo, value: fileNo })) || []);
//             } catch (error) {
//                 console.error("Error fetching dropdown data:", error);
//                 toast.error(t("text.ErrorFetchingFilters"));
//             }
//         };

//         fetchDropdownData();
//     }, [fetchData, t]);

//     // Filter Form Logic
//     interface FormValues {
//         docMid: number | null | string;
//         fileTypId: number | null | string;
//         divisionid: number | null | string;
//         subsubjId: number | null | string;
//         user_Id: number | null | string;
//         fileNo: string | null;
//         perFr: string;
//         perUt: string;
//         complt: string | null;
//     }

//     const initialValues: FormValues = {
//         docMid: null,
//         fileTypId: null,
//         divisionid: null,
//         subsubjId: null,
//         user_Id: null,
//         fileNo: null,
//         perFr: "",
//         perUt: "",
//         complt: null,
//     };

//     const formik = useFormik({
//         initialValues: initialValues,
//         onSubmit: async (values) => {
//             console.log("Submitting filters:", values);
//             await fetchData(values);
//         },
//     });

//     // Event Handlers
//     const handleFilterButtonClick = () => {
//         setFilterDrawerOpen((prev) => !prev);
//     };

//     const handleRowClick = (rowData: any) => {
//         setSelectedRow(rowData);
//         setDetailsDrawerOpen(true);
//     };

//     const handleDetailsDrawerClose = () => {
//         setDetailsDrawerOpen(false);
//         setSelectedRow(null);
//     };

//     const handlePrint = () => {
//         const contentElement = document.getElementById("report-table-container");
//         if (!contentElement) {
//             console.error("Print container not found.");
//             toast.error("Could not find table content to print.");
//             return;
//         }

//         const printWindow = window.open("", "_blank");
//         if (!printWindow) {
//             toast.error("Could not open print window. Check browser pop-up blocker.");
//             return;
//         }

//         const clonedContent = contentElement.cloneNode(true) as HTMLElement;

//         const styles = `
//             <style>
//                 body { font-family: sans-serif; margin: 20px; }
//                 table { width: 100%; border-collapse: collapse; }
//                 th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
//                 th { background-color: #f2f2f2; }
//                 @media print {
//                     .no-print { display: none !important; }
//                 }
//             </style>
//         `;

//         printWindow.document.write(`
//             <html>
//                 <head>
//                     <title>${t("text.DocManagerReport")} - ${new Date().toLocaleDateString()}</title>
//                     ${styles}
//                 </head>
//                 <body>
//                     <div style="display: flex; align-items: center; margin-bottom: 20px;">
//                         <img src="${loged}" alt="Logo" style="height: 60px; margin-right: 20px;" />
//                         <h2>${t("text.DocManagerReport")}</h2>
//                     </div>
//                     ${clonedContent.outerHTML}
//                 </body>
//             </html>
//         `);

//         printWindow.document.close();
//         printWindow.focus();
//         setTimeout(() => {
//             printWindow.print();
//             printWindow.close();
//         }, 500);
//     };

//     const handleClear = () => {
//         formik.resetForm();
//         formik.setFieldValue("divisionid", null);
//         formik.setFieldValue("subsubjId", null);
//         formik.setFieldValue("fileTypId", null);
//         formik.setFieldValue("fileNo", null);
//         formik.setFieldValue("complt", null);
//         fetchData(initialValues);
//         setSearchTerm("");
//         toast.info(t("text.FiltersCleared"));
//     };

//     return (
//         <>
//             <ToastApp />
//             <Card
//                 style={{
//                     width: "100%",
//                     backgroundColor: "var(--page-background-color, #E9FDEE)",
//                     border: ".5px solid #ccc",
//                     marginTop: "2vh",
//                 }}
//             >
//                 <Paper
//                     sx={{
//                         width: "100%",
//                         overflow: "hidden",
//                         position: 'relative',
//                         backgroundImage: `url(${loged})`,
//                         backgroundRepeat: 'no-repeat',
//                         backgroundPosition: 'center',
//                         backgroundSize: '300px',
//                         backgroundBlendMode: 'lighten',
//                         backgroundColor: 'rgba(255, 255, 255, 0.9)',
//                     }}
//                     style={{ padding: "15px" }}
//                 >
//                     {/* Header Section */}
//                     <Grid container justifyContent="space-between" alignItems="center" sx={{ padding: "10px 20px" }}>
//                         <Grid item>
//                             <Typography variant="h5" component="div">
//                                 {t("text.DocManagerReport")}
//                             </Typography>
//                         </Grid>
//                         <Grid item sx={{ display: 'flex', gap: 2 }}>
//                             <Button
//                                 variant="contained"
//                                 startIcon={<FilterAltIcon />}
//                                 onClick={handleFilterButtonClick}
//                                 className="no-print"
//                                 sx={{ textTransform: 'none' }}
//                             >
//                                 {t("text.Filter")}
//                             </Button>
//                             <Button
//                                 variant="contained"
//                                 color="secondary"
//                                 startIcon={<PrintIcon />}
//                                 onClick={handlePrint}
//                                 className="no-print"
//                                 sx={{ textTransform: 'none' }}
//                                 disabled={loading || data.length === 0}
//                             >
//                                 {t("text.Print")}
//                             </Button>
//                         </Grid>
//                     </Grid>

//                     <Divider sx={{ marginY: 2 }} />



//                     {/* Filter Drawer */}
//                     <Collapse in={filterDrawerOpen} timeout="auto" unmountOnExit className="no-print">
//                         <Card variant="outlined" sx={{ p: 2, mb: 2, backgroundColor: 'background.paper' }}>
//                             <Typography variant="subtitle1" gutterBottom sx={{ mb: 2, fontWeight: 'medium' }}>
//                                 {t("text.FilterOptions")}
//                             </Typography>
//                             <Box component="form" onSubmit={formik.handleSubmit} id="filter-collapse-content">
//                                 <Grid container spacing={2.5}>
//                                     {/* Filter Inputs */}
//                                     <Grid item xs={12} sm={6} md={3}>
//                                         <Autocomplete
//                                             disablePortal
//                                             options={optionDivision}
//                                             getOptionLabel={(option) => option.label || ""}
//                                             fullWidth
//                                             size="small"
//                                             value={optionDivision.find(opt => opt.value === formik.values.divisionid) || null}
//                                             onChange={(event, newValue) => {
//                                                 formik.setFieldValue("divisionid", newValue?.value ?? null);
//                                             }}
//                                             renderInput={(params) => (
//                                                 <TextField {...params} label={t("text.selectDet")} />
//                                             )}
//                                             isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={12} sm={6} md={3}>
//                                         <Autocomplete
//                                             disablePortal
//                                             options={optionSubSubject}
//                                             getOptionLabel={(option) => option.label || ""}
//                                             fullWidth
//                                             size="small"
//                                             value={optionSubSubject.find(opt => opt.value === formik.values.subsubjId) || null}
//                                             onChange={(event, newValue) => {
//                                                 formik.setFieldValue("subsubjId", newValue?.value ?? null);
//                                             }}
//                                             renderInput={(params) => (
//                                                 <TextField {...params} label={t("text.SelectSubSubject")} />
//                                             )}
//                                             isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={12} sm={6} md={3}>
//                                         <Autocomplete
//                                             disablePortal
//                                             options={optionFileType}
//                                             getOptionLabel={(option) => option.label || ""}
//                                             fullWidth
//                                             size="small"
//                                             value={optionFileType.find(opt => opt.value === formik.values.fileTypId) || null}
//                                             onChange={(event, newValue) => {
//                                                 formik.setFieldValue("fileTypId", newValue?.value ?? null);
//                                             }}
//                                             renderInput={(params) => (
//                                                 <TextField {...params} label={t("text.SelectFileType")} />
//                                             )}
//                                             isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={12} sm={6} md={3}>
//                                         <Autocomplete
//                                             freeSolo
//                                             disablePortal
//                                             options={optionFileNo}
//                                             getOptionLabel={(option) => typeof option === 'string' ? option : option.label || ""}
//                                             fullWidth
//                                             size="small"
//                                             value={optionFileNo.find(opt => opt.value === formik.values.fileNo) || formik.values.fileNo || null}
//                                             onChange={(event, newValue) => {
//                                                 formik.setFieldValue("fileNo", typeof newValue === 'string' ? newValue : newValue?.value ?? null);
//                                             }}
//                                             renderInput={(params) => (
//                                                 <TextField {...params} label={t("text.SelectOrEnterFileNo")} />
//                                             )}
//                                             isOptionEqualToValue={(option, value) => option.value === value?.value}
//                                         />
//                                     </Grid>

//                                     {/* Filter Actions */}
//                                     <Grid item xs={12}>
//                                         <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ mt: 1 }}>
//                                             <Button
//                                                 type="button"
//                                                 variant="outlined"
//                                                 color="secondary"
//                                                 onClick={handleClear}
//                                                 disabled={loading}
//                                                 sx={{ textTransform: 'none' }}
//                                             >
//                                                 {t("text.Clear")}
//                                             </Button>
//                                             <Button
//                                                 type="submit"
//                                                 variant="contained"
//                                                 color="primary"
//                                                 disabled={loading}
//                                                 sx={{ textTransform: 'none' }}
//                                                 startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
//                                             >
//                                                 {loading ? t("text.Searching") + "..." : t("text.Search")}
//                                             </Button>
//                                         </Stack>
//                                     </Grid>
//                                 </Grid>
//                             </Box>
//                         </Card>
//                     </Collapse>

//                     {/* Search Box */}
//                     <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start' }} className="no-print">
//                         <TextField
//                             placeholder={t("text.Search") + "..."}
//                             value={searchTerm}
//                             onChange={handleSearch}
//                             size="small"
//                             sx={{ width: 300 }}
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <SearchIcon />
//                                     </InputAdornment>
//                                 ),
//                             }}
//                         />
//                     </Box>

//                     {/* Table Area */}
//                     <TableContainer
//                         component={Paper}
//                         id="report-table-container"
//                         sx={{
//                             maxHeight: "65vh",
//                             marginTop: 2,
//                             border: "1px solid #ddd",
//                             overflowX: 'auto',
//                         }}
//                     >
//                         <Table stickyHeader aria-label="document manager reports table" sx={{ minWidth: 1000 }}>
//                             <TableHead>
//                                 <TableRow>
//                                     <StyledTableCell align="center">{t("text.SrNo")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.FileName")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.deptName")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.Subject")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.FileNo")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.FileType")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.SubSubjectName")}</StyledTableCell>
//                                     <StyledTableCell align="left">{t("text.Date")}</StyledTableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {loading ? (
//                                     <TableRow>
//                                         <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
//                                             <CircularProgress />
//                                             <Typography sx={{ marginTop: 1 }}>{t("text.LoadingData")}...</Typography>
//                                         </TableCell>
//                                     </TableRow>
//                                 ) : error ? (
//                                     <TableRow>
//                                         <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
//                                             <Alert severity="error" sx={{ justifyContent: 'center' }}>{error}</Alert>
//                                         </TableCell>
//                                     </TableRow>
//                                 ) : filteredData.length === 0 ? (
//                                     <TableRow>
//                                         <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
//                                             <Typography>{searchTerm ? t("text.NoMatchingResults") : t("text.NoReportsFound")}</Typography>
//                                         </TableCell>
//                                     </TableRow>
//                                 ) : (
//                                     filteredData
//                                         .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                                         .map((row: any, index: number) => (
//                                             <Row
//                                                 key={row.docMid || index}
//                                                 row={row}
//                                                 index={page * rowsPerPage + index}
//                                                 onRowClick={handleRowClick}
//                                             />
//                                         ))
//                                 )}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>

//                     {/* Pagination */}
//                     {!loading && filteredData.length > 0 && (
//                         <TablePagination
//                             rowsPerPageOptions={[5, 10, 25, 50]}
//                             component="div"
//                             count={filteredData.length}
//                             rowsPerPage={rowsPerPage}
//                             page={page}
//                             onPageChange={handleChangePage}
//                             onRowsPerPageChange={handleChangeRowsPerPage}
//                             sx={{ mt: 2 }}
//                             className="no-print"
//                         />
//                     )}
//                 </Paper>
//             </Card>

//             {/* Details Drawer */}
//             <DocMngSwipeableDrawer
//                 open={detailsDrawerOpen}
//                 onClose={handleDetailsDrawerClose}
//                 title={selectedRow ? `# ${selectedRow?.synopsis || 'N/A'} ${t('text.Details')}` : t('text.DocumentManager')}
//                 userData={selectedRow}
//             />
//         </>
//     );
// }


















import React, { useState, useEffect, useCallback } from "react";
import {
    Button,
    Card,
    Divider,
    Paper,
    Grid,
    Typography,
    TextField,
    CircularProgress,
    Alert,
    Collapse,
    Box,
    Stack,
    TablePagination,
    InputAdornment,
    IconButton,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import ToastApp from "../../../ToastApp";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import PrintIcon from "@mui/icons-material/Print";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import DocMngSwipeableDrawer from "./DocMngSwipeableDrawer";
import loged from "../../../assets/images/DrawerLogo.png";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";

// --- Styled Components ---
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: `var(--header-background, #00009C)`,
        color: `var(--header-color, ${theme.palette.common.white})`,
        whiteSpace: 'nowrap',
        padding: '8px 12px',
        fontSize: '0.875rem',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '0.8125rem',
        padding: '8px 12px',
        maxWidth: '200px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
    "& td, & th": {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
    "& td:last-child, & th:last-child": {
        borderRight: 0,
    }
}));

// Define types for filter options
interface FilterOption {
    label: string;
    value: number | string;
}

// Define types for PDF Preview Modal props
interface PdfPreviewModalProps {
    open: boolean;
    onClose: () => void;
    data: any[];
    filters: FormValues | null;
    totalRecords: number;
    logo: string;
    optionDivision: FilterOption[];
    optionSubSubject: FilterOption[];
    optionFileType: FilterOption[];
}

// --- PDF Preview Modal Component ---

const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({
    open,
    onClose,
    data,
    filters,
    totalRecords,
    logo,
    optionDivision,
    optionSubSubject,
    optionFileType,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleDownload = () => {
        setIsLoading(true);
        setTimeout(() => {
            const contentElement = document.getElementById("pdf-preview-content");
            if (!contentElement) {
                toast.error("Could not find content to download.");
                setIsLoading(false);
                return;
            }

            const printWindow = window.open("", "_blank");
            if (!printWindow) {
                toast.error("Could not open download window. Check browser pop-up blocker.");
                setIsLoading(false);
                return;
            }

            const clonedContent = contentElement.cloneNode(true) as HTMLElement;

            const styles = `
                <style>
                    body {
                        font-family: 'Times New Roman', serif;
                        margin: 0;
                        padding: 20px;
                        color: #000;
                        background: #fff;
                        font-size: 13px;
                    }
                    .report-header {
                        display: flex;
                        align-items: center;
                        margin-bottom: 15px;
                        border-bottom: 2px solid #000080;
                        padding-bottom: 6px;
                    }
                    .report-header img {
                        height: 80px !important; /* Bigger logo only in print */
                    }
                    .report-title {
                        margin-left: 20px;
                        color: #000080;
                    }
                    .report-title h1 {
                        font-size: 22px !important;
                        margin: 0;
                        font-weight: bold;
                    }
                    .report-title small {
                        font-size: 12px;
                        color: #333;
                    }
                    .report-meta {
                        margin-bottom: 15px;
                        padding: 4px 5px;
                        border: 1px solid #000;
                        background: #f9f9f9;
                        font-size: 12px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        gap: 5px;
                    }
                    .report-meta p, 
                    .report-meta span, 
                    .report-meta div {
                        margin: 0;
                        display: inline-block; /* ✅ Prevent stacking */
                    }
                    .report-table {
                        width: 100%;
                        border: 1px solid #000;
                        border-collapse: collapse;
                        margin-bottom: 15px;
                    }
                    .report-table th,
                    .report-table td {
                        border: 1px solid #000;
                        padding: 6px;
                        font-size: 12px;
                        text-align: left;
                    }
                    .report-table th {
                        background: #000080;
                        color: #fff;
                        font-weight: bold;
                        text-transform: uppercase;
                        font-size: 11px;
                    }
                    .report-footer {
                        margin-top: 20px;
                        padding-top: 6px;
                        border-top: 1px solid #000;
                        text-align: right;
                        font-size: 11px;
                    }
                    .logo-watermark {
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        opacity: 0.07;
                        width: 300px;
                        height: 300px;
                        background-image: url('${logo}');
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                        pointer-events: none;
                        z-index: -1;
                    }
                </style>
            `;

            printWindow.document.write(`
                <html>
                    <head>
                        <title>Official Report - ${moment(new Date()).format("DD/MM/YYYY")}</title>
                        ${styles}
                    </head>
                    <body>
                        <div class="logo-watermark"></div>
                        ${clonedContent.outerHTML}
                    </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                setIsLoading(false);
                toast.success("PDF is ready for printing");
            }, 500);
        }, 1000);
    };

    const getFilterDescription = () => {
        if (!filters) return "All Records";
        let description = "";
        if (filters.divisionid && filters.divisionid !== -1) {
            const department = optionDivision.find(d => d.value === filters.divisionid);
            if (department) description += `Department: ${department.label}, `;
        }
        if (filters.subsubjId && filters.subsubjId !== -1) {
            const subject = optionSubSubject.find(s => s.value === filters.subsubjId);
            if (subject) description += `Subject: ${subject.label}, `;
        }
        if (filters.fileTypId && filters.fileTypId !== -1) {
            const fileType = optionFileType.find(f => f.value === filters.fileTypId);
            if (fileType) description += `File Type: ${fileType.label}, `;
        }
        if (filters.fileNo) description += `File No: ${filters.fileNo}, `;
        if (filters.perFr && filters.perUt) description += `Period: ${filters.perFr} - ${filters.perUt}, `;
        return description ? description.replace(/,\s*$/, "") : "All Records";
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    height: "92vh",
                    maxHeight: "92vh",
                    borderRadius: 0,
                    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                }
            }}
        >
            {/* Header */}
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "#000080",
                    color: "white",
                    py: 1.2,
                    px: 2
                }}
            >
                <Box display="flex" alignItems="center">
                    <PictureAsPdfIcon sx={{ mr: 1, color: "white" }} />
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        Official Document Report
                    </Typography>
                </Box>
                <IconButton onClick={onClose} sx={{ color: "white" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            {/* Content */}
            <DialogContent
                dividers
                sx={{
                    background: "#fff",
                    px: 2,
                    py: 1.5,
                }}
            >
                {/* Watermark */}
                <Box
                    className="no-print"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        opacity: 0.07,
                        width: "300px",
                        height: "300px",
                        backgroundImage: `url(${logo})`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        pointerEvents: "none",
                        zIndex: -1
                    }}
                />

                <Box id="pdf-preview-content">
                    {/* Report Header */}
                    <Box
                        className="report-header"
                        sx={{ display: "flex", alignItems: "center", borderBottom: "2px solid #000080", pb: 1, mb: 2 }}
                    >
                        <img
                            src={logo}
                            alt="Logo"
                            style={{ maxHeight: "60px", width: "auto", objectFit: "contain" }} // ✅ Fixed preview sizing
                        />
                        <Box className="report-title" sx={{ ml: 2 }}>
                            <h1 style={{ fontSize: "22px", margin: 0, color: "#000080" }}>CSA - Document Management Report</h1>
                            <small>{moment(new Date()).format("DD/MM/YYYY")}</small>
                        </Box>
                    </Box>

                    {/* Filters */}
                    <Box className="report-meta" sx={{ display: "flex", justifyContent: "space-between", mb: 2, border: "1px solid #000", p: .5, background: "#f9f9f9" }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 0.5 }}>
                            Report Filters
                        </Typography>
                        <Typography variant="body2">{getFilterDescription()}</Typography>
                        <Typography variant="body2" sx={{ mt: 0.5, fontWeight: "bold" }}>
                            Total Records: {totalRecords}
                        </Typography>
                    </Box>

                    {/* Table */}
                    <table className="report-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th>Sr No</th>
                                <th>File Name</th>
                                <th>Department</th>
                                <th>Subject</th>
                                <th>File No</th>
                                <th>File Type</th>
                                <th>Sub Subject</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{row.synopsis || "N/A"}</td>
                                    <td>{row.department_Name || "-"}</td>
                                    <td>{row.sub_Subject_Name || "-"}</td>
                                    <td>{row.fileNo || "-"}</td>
                                    <td>{row.fileType_Name || "-"}</td>
                                    <td>{row.sub_Subject_Name || "-"}</td>
                                    <td>{row.createdate ? moment(row.createdate).format("DD/MM/YYYY") : "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Footer */}
                    <Box className="report-footer" sx={{ mt: 3, borderTop: "1px solid #000", pt: 1, textAlign: "right" }}>
                        <Typography variant="body2">Generated On: {moment(new Date()).format("DD/MM/YYYY")}</Typography>
                        <Typography variant="body2">Page 1 of 1</Typography>
                    </Box>
                </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions
                sx={{
                    justifyContent: "space-between",
                    p: 1.5,
                    borderTop: "1px solid #000"
                }}
            >
                <Typography variant="body2" color="textSecondary">
                    Total Records: {totalRecords}
                </Typography>
                <Box>
                    <Button onClick={onClose} sx={{ mr: 1 }} variant="outlined" color="inherit">
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        sx={{ backgroundColor: "#000080", "&:hover": { backgroundColor: "#000066" } }}
                        startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <DownloadIcon />}
                        onClick={handleDownload}
                        disabled={isLoading}
                    >
                        {isLoading ? "Preparing..." : "Download PDF"}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};




// const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({
//     open,
//     onClose,
//     data,
//     filters,
//     totalRecords,
//     logo,
//     optionDivision,
//     optionSubSubject,
//     optionFileType,
// }) => {
//     const [isLoading, setIsLoading] = useState(false);

//     const handleDownload = () => {
//         setIsLoading(true);
//         setTimeout(() => {
//             const contentElement = document.getElementById("pdf-preview-content");
//             if (!contentElement) {
//                 toast.error("Could not find content to download.");
//                 setIsLoading(false);
//                 return;
//             }

//             const printWindow = window.open("", "_blank");
//             if (!printWindow) {
//                 toast.error("Could not open download window. Check browser pop-up blocker.");
//                 setIsLoading(false);
//                 return;
//             }

//             const clonedContent = contentElement.cloneNode(true) as HTMLElement;

//             const styles = `
//                 <style>
//                     body { font-family: 'Segoe UI', sans-serif; margin: 0; padding: 24px; color: #333; background: #fff; }
//                     .report-header { display: flex; align-items: center; margin-bottom: 20px; }
//                     .report-title { margin-left: 16px; color: #1a237e; }
//                     .report-meta {
//                         margin-bottom: 20px;
//                         padding: 16px;
//                         background: #f4f6f9;
//                         border-radius: 10px;
//                         border-left: 5px solid #1a237e;
//                         box-shadow: 0 1px 3px rgba(0,0,0,0.08);
//                     }
//                     .report-table {
//                         width: 100%;
//                         border-collapse: collapse;
//                         border-radius: 8px;
//                         overflow: hidden;
//                         box-shadow: 0 2px 5px rgba(0,0,0,0.05);
//                     }
//                     .report-table th {
//                         background: #1a237e;
//                         color: #fff;
//                         padding: 10px 12px;
//                         text-align: left;
//                         font-size: 14px;
//                         text-transform: uppercase;
//                         letter-spacing: 0.5px;
//                     }
//                     .report-table td {
//                         padding: 10px 12px;
//                         border-bottom: 1px solid #eee;
//                         font-size: 14px;
//                     }
//                     .report-table tr:nth-child(even) { background: #fafafa; }
//                     .report-footer {
//                         margin-top: 32px;
//                         padding-top: 16px;
//                         border-top: 1px dashed #bbb;
//                         text-align: right;
//                         font-size: 13px;
//                         color: #666;
//                     }
//                     .logo-watermark {
//                         position: fixed;
//                         top: 50%;
//                         left: 50%;
//                         transform: translate(-50%, -50%);
//                         opacity: 0.08;
//                         width: 380px;
//                         height: 380px;
//                         background-image: url('${logo}');
//                         background-size: contain;
//                         background-repeat: no-repeat;
//                         background-position: center;
//                         pointer-events: none;
//                         z-index: -1;
//                     }
//                 </style>
//             `;

//             printWindow.document.write(`
//                 <html>
//                     <head>
//                         <title>Document Manager Report - ${new Date().toLocaleDateString()}</title>
//                         ${styles}
//                     </head>
//                     <body>
//                         <div class="logo-watermark"></div>
//                         ${clonedContent.outerHTML}
//                     </body>
//                 </html>
//             `);

//             printWindow.document.close();
//             printWindow.focus();
//             setTimeout(() => {
//                 printWindow.print();
//                 setIsLoading(false);
//                 toast.success("PDF is ready for printing");
//             }, 500);
//         }, 1000);
//     };

//     const getFilterDescription = () => {
//         if (!filters) return "All Records";
//         let description = "";
//         if (filters.divisionid && filters.divisionid !== -1) {
//             const division = optionDivision.find(d => d.value === filters.divisionid);
//             if (division) description += `Division: ${division.label}, `;
//         }
//         if (filters.subsubjId && filters.subsubjId !== -1) {
//             const subject = optionSubSubject.find(s => s.value === filters.subsubjId);
//             if (subject) description += `Subject: ${subject.label}, `;
//         }
//         if (filters.fileTypId && filters.fileTypId !== -1) {
//             const fileType = optionFileType.find(f => f.value === filters.fileTypId);
//             if (fileType) description += `File Type: ${fileType.label}, `;
//         }
//         if (filters.fileNo) description += `File No: ${filters.fileNo}, `;
//         if (filters.perFr && filters.perUt) description += `Period: ${filters.perFr} - ${filters.perUt}, `;
//         return description ? description.replace(/,\s*$/, "") : "All Records";
//     };

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             maxWidth="lg"
//             fullWidth
//             PaperProps={{
//                 sx: {
//                     height: "92vh",
//                     maxHeight: "92vh",
//                     borderRadius: "16px",
//                     overflow: "hidden",
//                     boxShadow: "0 8px 24px rgba(0,0,0,0.15)"
//                 }
//             }}
//         >
//             {/* Header */}
//             <DialogTitle
//                 sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     background: "linear-gradient(90deg, #1a237e, #3949ab)",
//                     color: "white",
//                     py: 2,
//                     px: 3
//                 }}
//             >
//                 <Box display="flex" alignItems="center">
//                     <PictureAsPdfIcon sx={{ mr: 1, color: "white" }} />
//                     <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                         Document Manager Report
//                     </Typography>
//                 </Box>
//                 <IconButton onClick={onClose} sx={{ color: "white" }}>
//                     <CloseIcon />
//                 </IconButton>
//             </DialogTitle>

//             {/* Content */}
//             <DialogContent
//                 dividers
//                 sx={{
//                     background: "#fafafa",
//                     position: "relative",
//                     overflow: "auto",
//                     px: 3,
//                     py: 2
//                 }}
//             >
//                 {/* Watermark */}
//                 <Box
//                     className="no-print"
//                     sx={{
//                         position: "absolute",
//                         top: "50%",
//                         left: "50%",
//                         transform: "translate(-50%, -50%)",
//                         opacity: 0.07,
//                         width: "380px",
//                         height: "380px",
//                         backgroundImage: `url(${logo})`,
//                         backgroundSize: "contain",
//                         backgroundRepeat: "no-repeat",
//                         backgroundPosition: "center",
//                         pointerEvents: "none",
//                         zIndex: -1
//                     }}
//                 />

//                 <Box id="pdf-preview-content">
//                     {/* Report Header */}
//                     <Box className="report-header">
//                         <img src={logo} alt="Logo" style={{ height: "55px" }} />
//                         <Box className="report-title">
//                             <Typography variant="h4" sx={{ fontWeight: "bold", color: "#1a237e" }}>
//                                 Document Report
//                             </Typography>
//                             <Typography variant="subtitle2" sx={{ color: "#777" }}>
//                                 {new Date().toLocaleDateString()}
//                             </Typography>
//                         </Box>
//                     </Box>

//                     {/* Filters */}
//                     <Box className="report-meta">
//                         <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>
//                             Report Filters
//                         </Typography>
//                         <Typography variant="body2">{getFilterDescription()}</Typography>
//                         <Typography variant="body2" sx={{ mt: 1, fontWeight: "bold" }}>
//                             Total Records: {totalRecords}
//                         </Typography>
//                     </Box>

//                     {/* Table */}
//                     <table className="report-table">
//                         <thead>
//                             <tr>
//                                 <th>Sr No</th>
//                                 <th>File Name</th>
//                                 <th>Department</th>
//                                 <th>Subject</th>
//                                 <th>File No</th>
//                                 <th>File Type</th>
//                                 <th>Sub Subject</th>
//                                 <th>Date</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {data.map((row, index) => (
//                                 <tr key={index}>
//                                     <td>{index + 1}</td>
//                                     <td>{row.synopsis || "N/A"}</td>
//                                     <td>{row.department_Name || "-"}</td>
//                                     <td>{row.sub_Subject_Name || "-"}</td>
//                                     <td>{row.fileNo || "-"}</td>
//                                     <td>{row.fileType_Name || "-"}</td>
//                                     <td>{row.sub_Subject_Name || "-"}</td>
//                                     <td>{row.createdate ? moment(row.createdate).format("DD/MM/YYYY") : "-"}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>

//                     {/* Footer */}
//                     <Box className="report-footer">
//                         <Typography variant="body2">Generated On: {new Date().toLocaleString()}</Typography>
//                         <Typography variant="body2">Page 1 of 1</Typography>
//                     </Box>
//                 </Box>
//             </DialogContent>

//             {/* Actions */}
//             <DialogActions
//                 sx={{
//                     justifyContent: "space-between",
//                     p: 2,
//                     borderTop: "1px solid #eee",
//                     background: "#f9f9f9"
//                 }}
//             >
//                 <Typography variant="body2" color="textSecondary">
//                     Total Records: {totalRecords}
//                 </Typography>
//                 <Box>
//                     <Button onClick={onClose} sx={{ mr: 1 }} variant="outlined">
//                         Close
//                     </Button>
//                     <Button
//                         variant="contained"
//                         sx={{
//                             background: "linear-gradient(90deg, #1a237e, #3949ab)",
//                             "&:hover": { background: "linear-gradient(90deg, #0d1b61, #303f9f)" }
//                         }}
//                         startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <DownloadIcon />}
//                         onClick={handleDownload}
//                         disabled={isLoading}
//                     >
//                         {isLoading ? "Preparing..." : "Download PDF"}
//                     </Button>
//                 </Box>
//             </DialogActions>
//         </Dialog>
//     );
// };


// --- Row Component ---
function Row({ row, index, onRowClick }: { row: any; index: number, onRowClick: (rowData: any) => void }) {
    const handleFileNameClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        onRowClick(row);
    };

    return (
        <StyledTableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
            <StyledTableCell align="center">{index + 1}</StyledTableCell>
            <StyledTableCell>
                <a
                    href="#"
                    style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                    onClick={handleFileNameClick}
                >
                    {row.synopsis || 'N/A'}
                </a>
            </StyledTableCell>
            <StyledTableCell title={row.sub_Subject_Name}>{row.sub_Subject_Name || '-'}</StyledTableCell>
            <StyledTableCell>{row.fileNo || '-'}</StyledTableCell>
            <StyledTableCell>{row.fileType_Name || '-'}</StyledTableCell>
            <StyledTableCell title={row.sub_Subject_Name}>{row.sub_Subject_Name || '-'}</StyledTableCell>
            <StyledTableCell title={row.department_Name}>{row.department_Name || '-'}</StyledTableCell>
            <StyledTableCell>
                {row.createdate ? new Date(row.createdate).toLocaleDateString() : '-'}
            </StyledTableCell>
        </StyledTableRow>
    );
}

// --- Main Component ---
const API_ENDPOINT = HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`;
const DEFAULT_FILTER_INT = -1;
const DEFAULT_FILTER_STRING = "";

// Define FormValues interface
interface FormValues {
    docMid: number | null | string;
    fileTypId: number | null | string;
    divisionid: number | null | string;
    subsubjId: number | null | string;
    user_Id: number | null | string;
    fileNo: string | null;
    perFr: string;
    perUt: string;
    complt: string | null;
}

export default function DocManagerReports() {
    const { t } = useTranslation();
    const [filterDrawerOpen, setFilterDrawerOpen] = useState(true);
    const [data, setData] = useState<any[]>([]);
    const [filteredData, setFilteredData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [detailsDrawerOpen, setDetailsDrawerOpen] = useState(false);
    const [pdfModalOpen, setPdfModalOpen] = useState(false);
    const [currentFilters, setCurrentFilters] = useState<FormValues | null>(null);

    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // Search state
    const [searchTerm, setSearchTerm] = useState("");

    // Filter dropdowns state
    const [optionSubSubject, setOptionSubSubject] = useState<FilterOption[]>([]);
    const [optionDivision, setOptionDivision] = useState<FilterOption[]>([]);
    const [optionFileType, setOptionFileType] = useState<FilterOption[]>([]);
    const [optionFileNo, setOptionFileNo] = useState<FilterOption[]>([]);

    // Static Options
    const statusOption = [
        { value: "1", label: t("text.Process") },
        { value: "2", label: t("text.Pending") },
        { value: "3", label: t("text.Complete") },
    ];

    // Handle pagination
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Handle search
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);

        if (term === "") {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item =>
                Object.values(item).some(val =>
                    val && val.toString().toLowerCase().includes(term)
                )
            );
            setFilteredData(filtered);
        }
        setPage(0); // Reset to first page when searching
    };

    // Apply search when data changes
    useEffect(() => {
        if (searchTerm) {
            const filtered = data.filter(item =>
                Object.values(item).some(val =>
                    val && val.toString().toLowerCase().includes(searchTerm)
                )
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(data);
        }
    }, [data, searchTerm]);

    // Fetch Data Function
    const fetchData = useCallback(async (filterParams: FormValues) => {
        setLoading(true);
        setError(null);
        setData([]);
        console.log("Fetching data with params:", filterParams);
        setCurrentFilters(filterParams);

        const payload = {
            docMid: filterParams.docMid || DEFAULT_FILTER_INT,
            fileTypId: filterParams.fileTypId || DEFAULT_FILTER_INT,
            divisionid: filterParams.divisionid || DEFAULT_FILTER_INT,
            subsubjId: filterParams.subsubjId || DEFAULT_FILTER_INT,
            user_Id: filterParams.user_Id || DEFAULT_FILTER_INT,
            fileNo: filterParams.fileNo || DEFAULT_FILTER_STRING,
            perFr: filterParams.perFr || DEFAULT_FILTER_STRING,
            perUt: filterParams.perUt || DEFAULT_FILTER_STRING,
            complt: filterParams.complt || DEFAULT_FILTER_STRING,
        };

        try {
            const response = await axios.post(API_ENDPOINT, payload);
            if (response.data.isSuccess) {
                setData(response.data.data || []);
                if (!response.data.data || response.data.data.length === 0) {
                    toast.info(t("text.NoDataFound"));
                }
            } else {
                setError(response.data.mesg || t("text.ErrorFetchingData"));
                toast.error(response.data.mesg || t("text.ErrorFetchingData"));
            }
        } catch (err: any) {
            console.error("API Error:", err);
            const errorMsg = err.response?.data?.mesg || err.message || t("text.NetworkError");
            setError(errorMsg);
            toast.error(errorMsg);
        } finally {
            setLoading(false);
        }
    }, [t]);

    // Fetch Initial Data and Dropdown Data
    useEffect(() => {
        fetchData({
            docMid: DEFAULT_FILTER_INT,
            fileTypId: DEFAULT_FILTER_INT,
            divisionid: DEFAULT_FILTER_INT,
            subsubjId: DEFAULT_FILTER_INT,
            user_Id: DEFAULT_FILTER_INT,
            fileNo: DEFAULT_FILTER_STRING,
            perFr: DEFAULT_FILTER_STRING,
            perUt: DEFAULT_FILTER_STRING,
            complt: DEFAULT_FILTER_STRING,
        });

        const fetchDropdownData = async () => {
            try {
                // SubSubject
                const subSubjRes = await axios.post(HOST_URL.HOST_URL2 + "SubSubjForPdf/GetSubSubjForPdf", { sSubId: -1 });
                setOptionSubSubject(subSubjRes.data.data.map((item: any) => ({ label: item.subSubj, value: item.sSubId })) || []);

                // Division
                const divisionRes = await axios.post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, { id: -1, nodeID: -1, titleID: -1 });
                setOptionDivision(divisionRes.data.data.map((item: any) => ({ label: item.name, value: item.id })) || []);

                // File Type
                const fileTypeRes = await axios.post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, { docID: -1, parentDocId: -1, userId: "" });
                setOptionFileType(fileTypeRes.data.data.map((item: any) => ({ label: item.doc_Name, value: item.docID })) || []);

                // File Number
                const fileNoRes: any = await axios.post(API_ENDPOINT, { docMid: -1, fileTypId: -1, divisionid: -1, subsubjId: -1, user_Id: -1, fileNo: "" });
                const distinctFileNos: any = Array.from(new Set(fileNoRes.data.data.map((item: any) => item.fileNo).filter(Boolean)));
                setOptionFileNo(distinctFileNos.map((fileNo: string) => ({ label: fileNo, value: fileNo })) || []);
            } catch (error) {
                console.error("Error fetching dropdown data:", error);
                toast.error(t("text.ErrorFetchingFilters"));
            }
        };

        fetchDropdownData();
    }, [fetchData, t]);

    const initialValues: FormValues = {
        docMid: null,
        fileTypId: null,
        divisionid: null,
        subsubjId: null,
        user_Id: null,
        fileNo: null,
        perFr: "",
        perUt: "",
        complt: null,
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: async (values) => {
            console.log("Submitting filters:", values);
            await fetchData(values);
        },
    });

    // Event Handlers
    const handleFilterButtonClick = () => {
        setFilterDrawerOpen((prev) => !prev);
    };

    const handleRowClick = (rowData: any) => {
        setSelectedRow(rowData);
        setDetailsDrawerOpen(true);
    };

    const handleDetailsDrawerClose = () => {
        setDetailsDrawerOpen(false);
        setSelectedRow(null);
    };

    const handlePrintPreview = () => {
        setPdfModalOpen(true);
    };

    const handlePrint = () => {
        const contentElement = document.getElementById("report-table-container");
        if (!contentElement) {
            console.error("Print container not found.");
            toast.error("Could not find table content to print.");
            return;
        }

        const printWindow = window.open("", "_blank");
        if (!printWindow) {
            toast.error("Could not open print window. Check browser pop-up blocker.");
            return;
        }

        const clonedContent = contentElement.cloneNode(true) as HTMLElement;

        const styles = `
            <style>
                body { font-family: sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; }
                @media print {
                    .no-print { display: none !important; }
                }
            </style>
        `;

        printWindow.document.write(`
            <html>
                <head>
                    <title>Document Manager Report - ${new Date().toLocaleDateString()}</title>
                    ${styles}
                </head>
                <body>
                    <div style="display: flex; align-items: center; margin-bottom: 20px;">
                        <img src="${loged}" alt="Logo" style="height: 60px; margin-right: 20px;" />
                        <h2>Document Manager Report</h2>
                    </div>
                    ${clonedContent.outerHTML}
                </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    const handleClear = () => {
        formik.resetForm();
        formik.setFieldValue("divisionid", null);
        formik.setFieldValue("subsubjId", null);
        formik.setFieldValue("fileTypId", null);
        formik.setFieldValue("fileNo", null);
        formik.setFieldValue("complt", null);
        fetchData(initialValues);
        setSearchTerm("");
        toast.info(t("text.FiltersCleared"));
    };

    return (
        <>
            <ToastApp />
            <Card
                style={{
                    width: "100%",
                    backgroundColor: "var(--page-background-color, #E9FDEE)",
                    border: ".5px solid #ccc",
                    marginTop: "2vh",
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                        position: 'relative',
                        backgroundImage: `url(${loged})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: '300px',
                        backgroundBlendMode: 'lighten',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    }}
                    style={{ padding: "15px" }}
                >
                    {/* Header Section */}
                    <Grid container justifyContent="space-between" alignItems="center" sx={{ padding: "10px 20px" }}>
                        <Grid item>
                            <Typography variant="h5" component="div">
                                {t("text.DocManagerReport")}
                            </Typography>
                        </Grid>
                        <Grid item sx={{ display: 'flex', gap: 2 }}>
                            <Button
                                variant="contained"
                                startIcon={<FilterAltIcon />}
                                onClick={handleFilterButtonClick}
                                className="no-print"
                                sx={{ textTransform: 'none' }}
                            >
                                {t("text.Filter")}
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<PrintIcon />}
                                onClick={handlePrintPreview}
                                className="no-print"
                                sx={{ textTransform: 'none' }}
                                disabled={loading || data.length === 0}
                            >
                                {t("text.PrintPreview")}
                            </Button>
                        </Grid>
                    </Grid>

                    <Divider sx={{ marginY: 2 }} />

                    {/* Filter Drawer */}
                    <Collapse in={filterDrawerOpen} timeout="auto" unmountOnExit className="no-print">
                        <Card variant="outlined" sx={{ p: 2, mb: 2, backgroundColor: 'background.paper' }}>
                            <Typography variant="subtitle1" gutterBottom sx={{ mb: 2, fontWeight: 'medium' }}>
                                {t("text.FilterOptions")}
                            </Typography>
                            <Box component="form" onSubmit={formik.handleSubmit} id="filter-collapse-content">
                                <Grid container spacing={2.5}>
                                    {/* Filter Inputs */}
                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            disablePortal
                                            options={optionDivision}
                                            getOptionLabel={(option) => option.label || ""}
                                            fullWidth
                                            size="small"
                                            value={optionDivision.find(opt => opt.value === formik.values.divisionid) || null}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue("divisionid", newValue?.value ?? null);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label={t("text.selectDet")} />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            disablePortal
                                            options={optionSubSubject}
                                            getOptionLabel={(option) => option.label || ""}
                                            fullWidth
                                            size="small"
                                            value={optionSubSubject.find(opt => opt.value === formik.values.subsubjId) || null}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue("subsubjId", newValue?.value ?? null);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label={t("text.SelectSubSubject")} />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            disablePortal
                                            options={optionFileType}
                                            getOptionLabel={(option) => option.label || ""}
                                            fullWidth
                                            size="small"
                                            value={optionFileType.find(opt => opt.value === formik.values.fileTypId) || null}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue("fileTypId", newValue?.value ?? null);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label={t("text.SelectFileType")} />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <Autocomplete
                                            freeSolo
                                            disablePortal
                                            options={optionFileNo}
                                            getOptionLabel={(option) => typeof option === 'string' ? option : option.label || ""}
                                            fullWidth
                                            size="small"
                                            value={optionFileNo.find(opt => opt.value === formik.values.fileNo) || formik.values.fileNo || null}
                                            onChange={(event, newValue) => {
                                                formik.setFieldValue("fileNo", typeof newValue === 'string' ? newValue : newValue?.value ?? null);
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label={t("text.SelectOrEnterFileNo")} />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        />
                                    </Grid>

                                    {/* Filter Actions */}
                                    <Grid item xs={12}>
                                        <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ mt: 1 }}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="secondary"
                                                onClick={handleClear}
                                                disabled={loading}
                                                sx={{ textTransform: 'none' }}
                                            >
                                                {t("text.Clear")}
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                disabled={loading}
                                                sx={{ textTransform: 'none' }}
                                                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                                            >
                                                {loading ? t("text.Searching") + "..." : t("text.Search")}
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Card>
                    </Collapse>

                    {/* Search Box */}
                    <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start' }} className="no-print">
                        <TextField
                            placeholder={t("text.Search") + "..."}
                            value={searchTerm}
                            onChange={handleSearch}
                            size="small"
                            sx={{ width: 300 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    {/* Table Area */}
                    <TableContainer
                        component={Paper}
                        id="report-table-container"
                        sx={{
                            maxHeight: "65vh",
                            marginTop: 2,
                            border: "1px solid #ddd",
                            overflowX: 'auto',
                        }}
                    >
                        <Table stickyHeader aria-label="document manager reports table" sx={{ minWidth: 1000 }}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">{t("text.SrNo")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.FileName")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.deptName")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.Subject")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.FileNo")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.FileType")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.SubSubjectName")}</StyledTableCell>
                                    <StyledTableCell align="left">{t("text.Date")}</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
                                            <CircularProgress />
                                            <Typography sx={{ marginTop: 1 }}>{t("text.LoadingData")}...</Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : error ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
                                            <Alert severity="error" sx={{ justifyContent: 'center' }}>{error}</Alert>
                                        </TableCell>
                                    </TableRow>
                                ) : filteredData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center" sx={{ padding: 4 }}>
                                            <Typography>{searchTerm ? t("text.NoMatchingResults") : t("text.NoReportsFound")}</Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    filteredData
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row: any, index: number) => (
                                            <Row
                                                key={row.docMid || index}
                                                row={row}
                                                index={page * rowsPerPage + index}
                                                onRowClick={handleRowClick}
                                            />
                                        ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Pagination */}
                    {!loading && filteredData.length > 0 && (
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component="div"
                            count={filteredData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{ mt: 2 }}
                            className="no-print"
                        />
                    )}
                </Paper>
            </Card>

            {/* Details Drawer */}
            <DocMngSwipeableDrawer
                open={detailsDrawerOpen}
                onClose={handleDetailsDrawerClose}
                title={selectedRow ? `# ${selectedRow?.synopsis || 'N/A'} ${t('text.Details')}` : t('text.DocumentManager')}
                userData={selectedRow}
            />

            {/* PDF Preview Modal */}
            <PdfPreviewModal
                open={pdfModalOpen}
                onClose={() => setPdfModalOpen(false)}
                data={filteredData}
                filters={currentFilters}
                totalRecords={filteredData.length}
                logo={loged}
                optionDivision={optionDivision}
                optionSubSubject={optionSubSubject}
                optionFileType={optionFileType}
            />
        </>
    );
}